import { Skeleton } from '@mui/material';

const DefaultUserConnectionFormSkeleton = () => (
  <>
    <Skeleton variant="rounded" height="56px" width="100%" />
    <Skeleton
      variant="text"
      width="26.5%"
      sx={{ fontSize: '1rem', mt: '0.1rem', ml: '0.875rem' }}
    />
    <Skeleton variant="rounded" height="36.5px" width="100%" sx={{ mt: '0.8rem' }} />
  </>
);

export default DefaultUserConnectionFormSkeleton;
